import { User } from '@firebase/auth'
import axios from 'axios'

import { FeedbackConfiguration, OrganisationConfiguration } from 'context/materialUI/types'

export async function fetchOrganisationConfiguration(
	user: User
): Promise<OrganisationConfiguration> {
	const userToken = await user.getIdToken()
	const response = await axios.get(`${process.env.REACT_APP_API_URL}/configuration/organisation`, {
		headers: {
			Authorization: userToken,
		},
	})
	return response.data
}

export const updateOrgConfiguration = async (user: User, localForm: OrganisationConfiguration) => {
	const response = await axios.put(
		`${process.env.REACT_APP_API_URL}/configuration/organisation`,
		localForm,
		{
			headers: {
				Authorization: await user.getIdToken(),
			},
		}
	)
	return response.data as OrganisationConfiguration
}

export async function fetchFeedbackConfiguration(user: User): Promise<FeedbackConfiguration> {
	const userToken = await user.getIdToken()
	const response = await axios.get(`${process.env.REACT_APP_API_URL}/configuration/feedback`, {
		headers: {
			Authorization: userToken,
		},
	})
	return response.data as FeedbackConfiguration
}

export const updateFeedbackConfiguration = async (user: User, localForm: FeedbackConfiguration) => {
	const response = await axios.put<FeedbackConfiguration>(
		`${process.env.REACT_APP_API_URL}/configuration/feedback`,
		localForm,
		{
			headers: {
				Authorization: await user.getIdToken(),
			},
		}
	)
	return response.data
}
